import { actionTypes, taskWorkOperationTypes, workplaceTypes } from "../types";
import { HeaderMenuBlock } from '../Block/HeaderMenuBlock/HeaderMenuBlock'

import { isEnabledMsg, isUnreadMsg } from "@/utils.js";
import { flightSchedule } from "./FlightSchedulePage";
import { modalContainerWarningCheckList } from "../Modal/ModalContainerWarningCheckList";
import { modalContainerWarningAudioRecord } from "../Modal/ModalContainerWarningAudioRecord";
import { ModalContainerAudioRecord } from "../Modal/ModalContainerAudioRecord";
import { modalContainerWarningCloseTask } from "@/Modal/ModalWarningCloseTask"
import { ModalContainerWarningEndOperationTime } from "../Modal/ModalWarningEndOperationTime";
import { VehicleNumberBlock } from "../Block/VehicleNumberBlock";
import { TIME_FORMAT, setCurrentDateTime  } from '@/utils.js'
import { appNotification } from '@/components/AppNotification.js'
import { storage } from "@/components/Storage";
import { user } from "@/components/User";
import { cache } from '@/components/Cache.js';
import { interval } from '@/components/Interval.js';
import { loader } from '@/components/Loader.js';
import { server } from '@/components/Server.js';
import { flightMenuBlock } from '@/Block/FlightMenuBlock.js';

const TaskWork = {
    list: [],
    state: {
        topMenu: [],
        data: {},
        errmsg: ''
    },

     // Формируем меню для текущего пользователя
    getTopMenu() {
        if (user.get('state.workplace') === workplaceTypes.driver) {
            const topMenu = [
                { title: 'Задачи', url: '/vehicle/tasks', icon: 'fa-tasks' },
                { title: 'Профиль', url: '/profile', icon: 'fa-user' },
                isEnabledMsg() ? { title: 'Сообщения', url: '/message', icon: isUnreadMsg() ? 'fa-envelope-o' : 'fa-envelope-open-o' } : {},
                { title: 'Выйти', url: '/logout', icon: 'fa-sign-out' }
            ];
            if (user.get('state.vehicleFreeTasksAvailable')) {
                topMenu.unshift({ title: 'Свободные', url: '/vehicle/tasks/free', icon: 'fa-car' });
            }
            return topMenu;
        } else {
            return [
                { title: 'Задачи', url: '/', icon: 'fa-tasks' },
                { title: 'Профиль', url: '/profile', icon: 'fa-user' },
                isEnabledMsg() ? { title: 'Сообщения', url: '/message', icon: isUnreadMsg() ? 'fa-envelope-o' : 'fa-envelope-open-o' } : {},
                { title: 'Выйти', url: '/logout', icon: 'fa-sign-out' }
            ];
        }
    },

    // тут заводится свой пинг, который еще доставляет readiness
    initPing: function () {
            var self = this;
            if (server.pingIntervalTimerId) 
                clearInterval(server.pingIntervalTimerId);
    
            server.pingIntervalTimerId = interval.make(function() {
                m.request({
                    method: 'POST',
                    url: '/api/ping?readiness=' + m.route.param('taskId'),
                    background: true,
                    extract(xhr) {
                        const statusErr = [401, 403]
                        const obj = xhr.response
                        return statusErr.includes(xhr.status) ? xhr.status : xhr.response;
                    }
                }).then(function (response) {
                    server.setOnline();
                    setCurrentDateTime(response.currentTime);
                    if (JSON.stringify(response.readiness) !== JSON.stringify(TaskWork.state.data.readiness)) {
                        TaskWork.state.data.readiness = response.readiness;
                        m.redraw();
                    }
                }, function (err) {
                    server.setOffline(err);
                });
            }, storage.config.pingFrequency * 1000);
        },

    init: function () {
        TaskWork.state.topMenu = TaskWork.getTopMenu();
        
        return m.request({
            method: 'GET',
            url: '/api/task/' + m.route.param('taskId') + '/works'
        }).then(function (response) {
            server.setOnline();

            TaskWork.state.data = response;
            TaskWork.state.errmsg = '';

            TaskWork.list = response.works;
            appNotification.list = response.notifications;

            storage.config = response.config;

            TaskWork.initPing();
            appNotification.init();

            loader.hide();

            return response;
        }, function (response) {
            if (!response) {
                server.setOffline();
            }
            loader.hide();
        });
    },

    update: function (key, value) {
        if (TaskWork.state.data.works)
            TaskWork.state.data.works[key] = value;
    },

    setReadiness(taskId, status) {
        loader.show();
        m.request({
            method: 'PUT',
            url: `/api/tasks/${taskId}/readiness`,
            data: { status: status, updated_by: user.get('id') }
        }).then(
            (response) => {
                loader.hide()
                // если пришёл нужный ответ, обновим данные прямо в state
                if (response && response.result === 'OK' && typeof response.status !== 'undefined') {
                    let readiness = TaskWork.state.data.readiness;
                    if (readiness) {
                        for (let r of readiness) {
                            if (r.work_id == taskId) {
                                r.status = parseInt(response.status);
                                break;
                            }
                        }
                    }
                    m.redraw();
                }
            },
            (response) => {
                server.setOffline();
                loader.hide();
            }
        );
    },

    startTask: function (taskId) {
        TaskWork.state.errmsg = '';
        loader.show();

        m.request({
            method: 'PUT',
            url: '/api/task/' + taskId + '/start'
        }).then(() => {
            server.setOnline();
            loader.hide();
            m.route('/task/' + taskId + '/works');
        }, (response) => {
            cache.push({
                type: actionTypes.taskStart,
                taskId: taskId,
                ts: moment().format(TIME_FORMAT)
            });

            if (response && response.message) {
                TaskWork.state.errmsg = m(".alert.alert-danger", response.message);
            } else {
                server.setOffline();
            }
            loader.hide();
        });
    },

    finishTask: function (taskId, needConfirmation) {
        TaskWork.state.errmsg = '';
        if (needConfirmation && !confirm('Вы уверены, что хотите выполнить действие?')) return false;
        loader.show();

        m.request({
            method: 'PUT',
            url: '/api/task/' + taskId + '/finish'
        }).then((response) => {
            if (response.hasOwnProperty("error")) {
                loader.hide();
                ModalContainerWarningEndOperationTime.open();
            } else {
                server.setOnline();
                loader.hide();
                m.route('/');
            }
        }, (response) => {
            cache.push({
                type: actionTypes.taskFinish,
                taskId: taskId,
                ts: moment().format(TIME_FORMAT)
            });
            if (response && response.message) {
                TaskWork.state.errmsg = m(".alert.alert-danger", response.message);
            } else {
                server.setOffline();
            }
            loader.hide();
        });
    },

    setWorkCommonTime: function (key) {
        TaskWork.state.errmsg = '';
        loader.show();

        const state = TaskWork.state.data.works[key];
        const data = {
            actionType: taskWorkOperationTypes.setTime,
            workId: parseInt(state.id)
        };

        m.request({
            method: 'PUT',
            url: '/api/task/' + m.route.param('taskId') + '/works',
            data: data
        }).then((response) => {
            TaskWork.update(key, response.work);
            if (TaskWork.state.data.works[key + 1] !== undefined) {
                TaskWork.state.data.works[key + 1].active = true;
            }
            server.setOnline();
            loader.hide();
        }, (response) => {
            data.type = actionTypes.taskWorkUpdate;
            data.taskId = m.route.param('taskId');
            data.ts = moment().format(TIME_FORMAT)
            cache.push(data);

            if (response && response.message) {
                TaskWork.state.errmsg = m(".alert.alert-danger", response.message);
            } else {
                server.setOffline();
            }
            loader.hide();
        });
    },

    cancelWork: function (key) {
        TaskWork.state.errmsg = '';
        loader.show();

        const state = TaskWork.state.data.works[key];
        const data = {
            actionType: taskWorkOperationTypes.cancelWork,
            workId: parseInt(state.id)
        };

        m.request({
            method: 'PUT',
            url: '/api/task/' + m.route.param('taskId') + '/works',
            data: data
        }).then((response) => {
            TaskWork.update(key, response.work);
            if (TaskWork.state.data.works[key + 1] !== undefined) {
                TaskWork.state.data.works[key + 1].active = true;
            }
            server.setOnline();
            loader.hide();
        }, (response) => {
            data.type = actionTypes.taskWorkUpdate;
            data.taskId = m.route.param('taskId');
            data.ts = moment().format(TIME_FORMAT);
            cache.push(data);

            if (response && response.message) {
                TaskWork.state.errmsg = m(".alert.alert-danger", response.message);
            } else {
                server.setOffline();
            }
            loader.hide();
        });
    },

    readinessButtonClick: function(event) {
        let btn = event.target;
        if (btn.constructor.name !== 'HTMLButtonElement')
            btn = btn.closest('button');
        if (!btn) return;

        const { taskId, status } = btn.dataset;
        if (!taskId || typeof status === 'undefined') return;

        TaskWork.setReadiness(taskId, (['null','0'].includes(status) ? '1' : '0'));
    }

};

export const TaskWorksPage = {
    controller: function () {
       if (!user.exists()) {
            m.route('/login');
            return;
        }
        if (user.get('state.workplace') !== workplaceTypes.executor && user.get('state.workplace') !== workplaceTypes.driver) {
            m.route('/');
            return;
        }
        interval.clearAll();
        loader.show();
        TaskWork.init();
        return TaskWork;
    },

    readinessButtons: function (readiness) {
        /* "work_id": "12",
            "status": "1",
            "updated_at": "2025-05-06 12:22:14",
            "name": "Пылесос",
        */
        return m(`div.container.d-flex.flex-column.gap-2`,
            (readiness || []).map((r) => {
                const color = !parseInt(r.status) ? 'success' : 'danger'
                const action = !parseInt(r.status) ? 'выдать готовность' : 'отменить готовность'
                return m(`button.btn.btn-lg.btn-${color}[type='button'][data-task-id='${r.work_id}'][data-status='${r.status}']`,
                    {
                        onclick: TaskWork.readinessButtonClick
                    },
                    [
                        m("", r.name),
                        m(`div[style='font-weight:100; font-size:0.9em;']`, action)
                    ]
                )
            })
        );

    },
    view: function (ctrl) {
        const state = ctrl.state;
        const data = ctrl.state.data;
        const currentTask = data.currentTask || {};
        const works = data.works || [];
        const readiness = data.readiness || [];
        const audioComment = data.audioComment || [];

        return [
            m.component(HeaderMenuBlock, {
                time: data.time,
                menu: state.topMenu
            }),
            m("div[style='margin-top:0px']", [
                VehicleNumberBlock(),
                m.component(flightMenuBlock, {
                    board: data.board,
                    menu: data.menu,
                    tasks: data.tasks,
                    currentTask: data.currentTask,
                    tab: 'works'
                })
            ]),
            state.errmsg,
            m("div[style='padding:7px 15px']", [
                currentTask.factBeginDateTime ?
                    m(".text-center.alert.alert-info", "Дата начала работы: " + currentTask.factBeginDateTime) :
                    m("button.btn.btn-info.btn-block.btn-lg", {
                        onclick: () => TaskWork.startTask(currentTask.taskId)
                    }, `Начать работу (${currentTask.Work_Name}) (${currentTask.planBeginTime})`)
            ]),
            works.length > 0 ?
                m("table.table.table-bordered.table-condensed", [
                    m("tbody", [
                        works.map(function (work, i) {
                            return [
                                m("tr", [
                                    m("td.col-xs-8",
                                        work.processed ?
                                            m("span.big-text", work.title) :
                                            m("button.btn.btn-info.btn-block.btn-lg", {
                                                onclick: () => TaskWork.setWorkCommonTime(i),
                                                disabled: (!currentTask.factBeginDateTime || !work.active) ? 'disabled' : false
                                            }, work.title)
                                    ),
                                    m("td.col-xs-4",
                                        work.processed ?
                                            m("strong.big-text", work.workTime ? work.workTime : 'Пропущена') :
                                            m("button.btn.btn-warning.btn-block.btn-lg", {
                                                onclick: () => TaskWork.cancelWork(i),
                                                disabled: (!currentTask.factBeginDateTime || !work.active) ? 'disabled' : false
                                            }, 'Пропустить')
                                    )
                                ])
                            ];
                        })
                    ])
                ]) : '',
            this.readinessButtons(readiness),
            m("div[style='padding:7px 15px']", [
                m("b", {}, "Комментарий к работе")
            ]),
            m("div[style='padding:7px 15px']", [
                m("div[style='width: 100%;display: inline-flex;flex-direction: row;']", [
                    m("textarea.form-control.comment-" + currentTask.taskId, {
                        rows: 2,
                        name: 'comment',
                        placeholder: 'Введите комментарий',
                        onchange: function (e) {
                            if (data.currentTask)
                                data.currentTask.comment = e.target.value;
                        }
                    }, currentTask.comment || ''),
                    !currentTask.factFinishTime ? m("button.btn", {
                        onclick: function () {
                            var permissionMic = false;
                            if (!navigator.mediaDevices.enumerateDevices) {
                                alert("enumerateDevices() not supported.");
                            } else {
                                navigator.mediaDevices
                                    .enumerateDevices()
                                    .then((devices) => {
                                        for (let i = 0; i < devices.length; i++) {
                                            if (devices[i].kind == "audioinput" && devices[i].deviceId != "") {
                                                permissionMic = true;
                                                break;
                                            }
                                        }
                                        if (permissionMic) {
                                            let timerId = localStorage.getItem("audioTimerId");
                                            timerId !== 'underfined' ? timerId : 0;

                                            if (!timerId) {

                                                let event = new Event("startAudioRecord", { bubbles: false });
                                                document.dispatchEvent(event);

                                                let timerSec = 0;
                                                let maxTime = data.config.LengthAudioRecord;
                                                timerId = setInterval(function () {
                                                    timerSec++;
                                                    const minutes = Math.floor(timerSec / 60);
                                                    const seconds = timerSec - minutes * 60;
                                                    let formatted = [
                                                        minutes.toString().padStart(2, '0'),
                                                        seconds.toString().padStart(2, '0')
                                                    ].join(':');
                                                    document.getElementById("audioTimer").innerHTML = formatted;
                                                    if (timerSec == maxTime) {
                                                        localStorage.setItem("lengthAudio", formatted);
                                                        ModalContainerAudioRecord.close(true);
                                                        let buttons = document.createElement("div");
                                                        buttons.className = "col-12";
                                                        let btn_ok = document.createElement("button");
                                                        btn_ok.classList.add('btn', 'btn-warning', 'btn-md');
                                                        btn_ok.innerText = "OK";
                                                        btn_ok.onclick = modalContainerWarningAudioRecord.close;
                                                        buttons.append(btn_ok);

                                                        modalContainerWarningAudioRecord
                                                            .open("Предупреждение",
                                                                "Записан аудиокомментарий максимальной длительности",
                                                                buttons);
                                                    }
                                                }, 1000, timerSec, maxTime);
                                                localStorage.setItem("audioTimerId", timerId);
                                            }
                                            ModalContainerAudioRecord.open();
                                        }
                                        else {
                                            alert("Необходимо разрешить браузеру доступ к микрофону");
                                        }
                                    })
                                    .catch((err) => {
                                        alert(err.name + err.message);
                                    });
                            }
                        }
                    }, [
                        m("div.record-button[id='mic_bg'][style='width:50px; height:50px']", [
                            m("i.fa.fa-2x.fa-thin.fa-microphone[id='mic_icon']")
                        ])
                    ]) : [],
                ]),
                m("button.btn.btn-info.btn-block[type='text'][style='margin-top:3px']", {
                    onclick: function () {
                        flightSchedule.saveWorkComment(this);
                    }
                }, "Сохранить комментарий")
            ]),
            m("div[id='audioRecords'][style='margin-top: 15px']", [
                audioComment.map(function (im) {
                    return m("div[name='" + im.fileID + "'][style='margin-top:4px']", [
                        m("audio[src=" + im.base64 + "]",
                            {
                                onended: function () {
                                    let button_play = this.parentNode.getElementsByTagName("button")[0];
                                    let i = button_play.getElementsByTagName("icon")[0];
                                    if (i.classList.contains("fa-pause")) {
                                        this.pause();
                                        i.classList.remove("fa-pause");
                                        i.classList.add("fa-play");
                                    }
                                }
                            }),
                        m("div.container[style='display: flex; justify-content: space-between;']", [
                            m("div[style='display: flex; align-items: center;']", [im.fileName]),
                            m("div", [
                                m("button", {
                                    onclick: function () {
                                        let i = this.getElementsByTagName("icon")[0];
                                        if (i.classList.contains("fa-play")) {
                                            let audio = this.parentNode.parentNode.parentNode.getElementsByTagName("audio")[0];
                                            audio.play();
                                            i.classList.remove("fa-play");
                                            i.classList.add("fa-pause");
                                        } else if (i.classList.contains("fa-pause")) {
                                            let audio = this.parentNode.parentNode.parentNode.getElementsByTagName("audio")[0];
                                            audio.pause();
                                            i.classList.remove("fa-pause");
                                            i.classList.add("fa-play");
                                        }
                                    }
                                }, [
                                    m("icon.fa.fa-play")
                                ]),
                                !currentTask.factFinishTime ? m("button[style='margin-left: 5px'][id='" + im.fileID + "']", {
                                    onclick: function (el) {
                                        localStorage.setItem("selectID", el.currentTarget.id);
                                        let buttons = document.createElement("div");
                                        let btn_yes = document.createElement("button");
                                        btn_yes.classList.add('col-6', 'btn', 'btn-warning', 'btn-md');
                                        btn_yes.innerText = "Да";
                                        btn_yes.onclick = function () {
                                            loader.show();
                                            modalContainerWarningAudioRecord.close();
                                            let id = localStorage.getItem("selectID");
                                            m.request({
                                                method: 'DELETE',
                                                url: '/api/task/' + m.route.param('taskId') + '/removeAudioComment',
                                                data: id
                                            }).then(function (response) {
                                                var loc_audio = localStorage.getItem("AudioRecords");
                                                loc_audio = JSON.parse(loc_audio);
                                                let id = localStorage.getItem("selectID");
                                                for (let i = 0; i < loc_audio.length; i++) {
                                                    if (loc_audio[i].fileID == id)
                                                        loc_audio.splice(i, 1);
                                                }
                                                localStorage.setItem("AudioRecords", JSON.stringify(loc_audio));
                                                let elem = document.getElementsByName(id);
                                                if (elem)
                                                    document.getElementsByName(id)[0].remove();
                                                loader.hide();
                                            }, function () {
                                                loader.hide();
                                            });
                                        };

                                        let btn_no = document.createElement("button");
                                        btn_no.classList.add('col-6', 'btn', 'btn-warning', 'btn-md');
                                        btn_no.style = "margin-left: 10px;";
                                        btn_no.innerText = "Нет";
                                        btn_no.onclick = modalContainerWarningAudioRecord.close;
                                        buttons.append(btn_yes);
                                        buttons.append(btn_no);

                                        modalContainerWarningAudioRecord
                                            .open("Предупреждение",
                                                "Вы действительно хотите удалить аудиосообщение?",
                                                buttons);
                                    }
                                }, [
                                    m("icon.fa.fa-trash")
                                ]) : []
                            ])
                        ])
                    ])
                })
            ]),
            ModalContainerAudioRecord.init("modalAudioRecord"),
            modalContainerWarningAudioRecord.init("modalWarningAudioRecord"),
            m(".container[style='padding:20px 0']", [
                currentTask.isConfirmed &&
                    currentTask.factBeginTime != null &&
                    data.showAccCard ?
                    m("button.btn.btn-danger.btn-block.btn-lg", {
                        onclick: function () {
                            m.route('/task/' + m.route.param('taskId') + '/accounting');
                        }
                    }, "Итоговая карта учета") : ''
            ]),
            m(".container[style='padding:20px 0']", [
                currentTask.isConfirmed ?
                    m("button.btn.btn-danger.btn-block.btn-lg", {
                        disabled: currentTask.factBeginDateTime
                            ? false
                            : 'disabled',
                        onclick: function () {
                            if (data.services) {
                                if (data.services.isFillValue !== -1) { // Если нет услуг, то надо дать завершить работу без проверок заполнения и подписи КУ
                                    if (currentTask.MandatoryFilling_DepDoc && currentTask.MandatorySignatured_DepDoc) {
                                        if (!data.services.isFillValue && !data.checkServiceCardsSign) {
                                            modalContainerWarningCloseTask.open("Предупреждение", "Не указано количество оказанных услуг по рейсу, карта учёта не подписана");
                                            return;
                                        }
                                    }
                                    if (currentTask.MandatoryFilling_DepDoc) {
                                        if (!data.services.isFillValue) {
                                            modalContainerWarningCloseTask.open("Предупреждение", "Не указано количество оказанных услуг по рейсу");
                                            return;
                                        }
                                    }
                                    if (currentTask.MandatorySignatured_DepDoc) {
                                        if (!data.checkServiceCardsSign) {
                                            modalContainerWarningCloseTask.open("Предупреждение", "Карта учёта не подписана.");
                                            return;
                                        }
                                    }
                                }
                            }

                            // Проверка подписи чек-листа
                            if (!localStorage.getItem("checkList"))
                                TaskWork.finishTask(currentTask.taskId, data.config.taskFinishConfirm);
                            else if (JSON.parse(localStorage.getItem("checkList")) === 1 ||
                                JSON.parse(localStorage.getItem("checkList")) === 2)
                                TaskWork.finishTask(currentTask.taskId, data.config.taskFinishConfirm);
                            else {
                                loader.show();
                                let BORT = JSON.parse(localStorage.getItem("checkList"))["BORT"];
                                m.request({
                                    method: 'GET',
                                    url: '/api/task/' + m.route.param('taskId') + '/getSignChecklist',
                                    data: BORT
                                }).then(function (response) {
                                    loader.hide();
                                    if (response.signChecklist.isOpen == false)
                                        TaskWork.finishTask(currentTask.taskId, data.config.taskFinishConfirm);
                                    else if (response.signChecklist.sign == false)
                                        modalContainerWarningCheckList.open("Чек-лист не подписан");
                                    else
                                        TaskWork.finishTask(currentTask.taskId, data.config.taskFinishConfirm);
                                }, function (response) {
                                    loader.hide();
                                    modalContainerWarningCheckList.open("Произошла ошибка! Чек-лист не подписан");
                                });
                            }

                        }
                    }, "Закончить работу (" + currentTask.planFinishTime + ")") : '',
                ModalContainerWarningEndOperationTime.init()
            ]),

        ];
    }
};